import { ganttFlatRowPinKey } from './ganttComparePins';
import type { GanttFlatRow } from './ganttSubtaskRows';
import { snapGanttTimelineDayMs } from './ganttTimelineViewSync';

export const GANTT_TIMELINE_ROW_HEIGHT = 36;
export const GANTT_TIMELINE_RIGHT_HEADER_PX = 54;
export const GANTT_TIMELINE_LEFT_HEADER_PX = 52;

export function ganttRowCenterOffsetPx(): number {
  const barTop = 6;
  const barHeight = GANTT_TIMELINE_ROW_HEIGHT - 12;
  return barTop + barHeight / 2;
}

export function hitTestGanttTimelinePointer(params: {
  flatRows: GanttFlatRow[];
  rangeStartMs: number;
  cellWidth: number;
  contentX: number;
  contentY: number;
}): { rowKey: string | null; timeMs: number | null } {
  const { flatRows, rangeStartMs, cellWidth, contentX, contentY } = params;
  if (flatRows.length === 0) return { rowKey: null, timeMs: null };
  const rowIdx = Math.max(0, Math.min(flatRows.length - 1, Math.floor(contentY / GANTT_TIMELINE_ROW_HEIGHT)));
  const rowKey = ganttFlatRowPinKey(flatRows[rowIdx]);
  if (cellWidth <= 0) return { rowKey, timeMs: null };
  const dayIdx = Math.max(0, Math.floor(contentX / cellWidth));
  const timeMs = snapGanttTimelineDayMs(new Date(rangeStartMs + dayIdx * 86400000));
  return { rowKey, timeMs };
}

export function projectGanttPeerCursor(params: {
  rowKey: string | null;
  timeMs: number | null;
  pane: 'chart' | 'left';
  flatRows: GanttFlatRow[];
  rangeStartMs: number;
  cellWidth: number;
  scrollLeft: number;
  scrollTop: number;
  leftPanelWidth: number;
  hideLeftPanel: boolean;
  pinnedRowCount: number;
}): { x: number; y: number } | null {
  const {
    rowKey,
    timeMs,
    pane,
    flatRows,
    rangeStartMs,
    cellWidth,
    scrollLeft,
    scrollTop,
    leftPanelWidth,
    hideLeftPanel,
    pinnedRowCount,
  } = params;
  if (!rowKey) return null;
  const rowIdx = flatRows.findIndex((r) => ganttFlatRowPinKey(r) === rowKey);
  if (rowIdx < 0) return null;
  const rowCenter = rowIdx * GANTT_TIMELINE_ROW_HEIGHT + ganttRowCenterOffsetPx();
  const pinPx = pinnedRowCount * GANTT_TIMELINE_ROW_HEIGHT;

  if (pane === 'left') {
    if (hideLeftPanel) return null;
    const y =
      GANTT_TIMELINE_LEFT_HEADER_PX + pinPx + (rowCenter - scrollTop);
    return { x: Math.max(12, leftPanelWidth * 0.35), y };
  }

  let x = leftPanelWidth + cellWidth * 0.5;
  if (timeMs != null && cellWidth > 0) {
    const dayIdx = Math.round((timeMs - rangeStartMs) / 86400000);
    x = leftPanelWidth + (dayIdx * cellWidth + cellWidth / 2 - scrollLeft);
  }
  const y = GANTT_TIMELINE_RIGHT_HEADER_PX + pinPx + (rowCenter - scrollTop);
  return { x, y };
}
